import { createFileRoute } from '@tanstack/react-router'

import { GrosirLandingPage, buildGrosirLpHead, loadGrosirLpData } from '../components/GrosirLp'
import { getGrosirLandingPath } from '../lib/grosirLanding'
import { storefrontResponseHeaders } from '../lib/storefrontResponse'

const SLUG = 'keset-karpet'
const PATH = getGrosirLandingPath(SLUG)

export const Route = createFileRoute('/grosir-keset-karpet')({
  loader: () => loadGrosirLpData(SLUG),
  headers: ({ loaderData }) => storefrontResponseHeaders(loaderData?.productsUnavailable ?? false),
  head: ({ loaderData }) => buildGrosirLpHead({ loaderData, slug: SLUG, path: PATH }),
  component: GrosirKesetKarpetRoute,
})

function GrosirKesetKarpetRoute() {
  const data = Route.useLoaderData()
  return <GrosirLandingPage data={data} showSocksPromo={false} isAdsRoute />
}
